export default "__VITE_ASSET__c61b91e1__"